import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXTermsOfUse implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxTermsOfUseContainer";
    }
    render(){
        // console.log("terms of use");
    }
}
